'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactionTypeTransitions = exports.default = undefined;

var _TransactionState = require('../eth/TransactionState');

var _TransactionState2 = _interopRequireDefault(_TransactionState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionType = {
  oasis: 'oasis',
  transaction: 'transaction'
};

var transactionLifeCycle = {
  initialized: [_TransactionState2.default.pending, _TransactionState2.default.error],
  pending: [_TransactionState2.default.error, _TransactionState2.default.mined],
  mined: [_TransactionState2.default.finalized, _TransactionState2.default.error],
  finalized: [],
  error: []
};

var transactionTypeTransitions = {
  transaction: transactionLifeCycle
};

exports.default = TransactionType;
exports.transactionTypeTransitions = transactionTypeTransitions;